export default __webpack_public_path__ + "static/media/rider-1.6c8281ce.jpg";